/* Michigan Mud Control — page section calculators + cart logic
   (Shopify AJAX Cart API). No header/footer/nav code here — this file
   only powers the Project Calculators section blocks. Your theme's
   existing header/cart icon keeps working exactly as it already does. */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Calculator logic ---- */
  function calcUnits(card) {
    var coverage = parseFloat(card.getAttribute('data-coverage'));
    var widthInput = card.querySelector('[data-mc-width]');
    var lengthInput = card.querySelector('[data-mc-length]');
    var resultEl = card.querySelector('[data-mc-result]');
    var labelPlural = card.getAttribute('data-label');

    var w = parseFloat(widthInput.value);
    var l = parseFloat(lengthInput.value);

    if (!w || !l || w <= 0 || l <= 0) {
      resultEl.innerHTML = '<span class="mc-calc-result__error">Please enter a valid width and length.</span>';
      resultEl.classList.remove('show');
      void resultEl.offsetWidth;
      resultEl.classList.add('show');
      return null;
    }

    var area = w * l;
    var units = Math.ceil(area / coverage);

    resultEl.innerHTML =
      '<span class="mc-calc-result__label">Estimated Quantity Needed</span>' +
      '<span class="mc-calc-result__value">' + units + '</span>' +
      '<span class="mc-calc-result__unit">' + labelPlural.toLowerCase() + ' &middot; ' + area.toFixed(1) + ' sq.ft. area</span>';
    resultEl.classList.remove('show');
    void resultEl.offsetWidth; // restart the fade/zoom animation
    resultEl.classList.add('show');
    return units;
  }

  /* ---- Add to Cart via Shopify AJAX Cart API ---- */
  function addToCart(card) {
    var units = calcUnits(card);
    if (units === null) return;

    var variantId = card.getAttribute('data-variant-id');
    var resultEl = card.querySelector('[data-mc-result]');
    var labelSingular = card.getAttribute('data-label-singular');
    var section = card.closest('[data-cart-url]');
    var cartUrl = (section && section.getAttribute('data-cart-url')) || '/cart';
    var shouldRedirect = !section || section.getAttribute('data-redirect-to-cart') !== 'false';

    if (!variantId) {
      resultEl.insertAdjacentHTML('beforeend',
        '<span class="mc-calc-result__error">No product is linked to this calculator yet. Please select a product in the theme editor.</span>');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: units }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not add to cart');
        return res.json();
      })
      .then(function () {
        resultEl.insertAdjacentHTML('beforeend',
          '<span class="mc-calc-result__success">&#10003; ' + units + ' &times; ' + labelSingular + ' added to cart' + (shouldRedirect ? ' — taking you to your cart&hellip;' : '.') + '</span>');
        if (shouldRedirect) {
          window.location.href = cartUrl;
        } else {
          notifyCartUpdated();
        }
      })
      .catch(function () {
        resultEl.insertAdjacentHTML('beforeend',
          '<span class="mc-calc-result__error">Sorry, that item could not be added to your cart.</span>');
      });
  }

  /* Let your theme's existing header/cart-drawer know the cart changed,
     so its cart icon count updates without a full page reload.
     This tries three approaches, in order of reliability:
       1. Common events themes listen for (cart:updated, cart:refresh).
       2. A global theme.refreshCart() function, if your theme exposes one.
       3. Re-fetching your ACTUAL header section's HTML from Shopify
          (Section Rendering API) and swapping in just the cart-count
          part — this works on most themes without any theme-specific
          code, since it asks Shopify to re-render your real header with
          the new cart count already baked in. */
  function notifyCartUpdated() {
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (window.theme && typeof window.theme.refreshCart === 'function') {
      window.theme.refreshCart();
    }
    refreshHeaderCartFragment();
  }

  function refreshHeaderCartFragment() {
    var headerWrapper = document.querySelector('[id^="shopify-section-header"], [id^="shopify-section-sticky-header"], [id^="shopify-section-announcement"]');
    if (!headerWrapper) return;
    var sectionId = headerWrapper.id.replace('shopify-section-', '');
    fetch(window.location.pathname + window.location.search + (window.location.search ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId))
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(headerWrapper.id);
        if (fresh) headerWrapper.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* silent — cart is still correct, icon just won't live-update */ });
  }

  document.querySelectorAll('[data-mc-calc-card]').forEach(function (card) {
    var calcBtn = card.querySelector('[data-mc-calc-btn]');
    var addBtn = card.querySelector('[data-mc-add-btn]');
    if (calcBtn) calcBtn.addEventListener('click', function () { calcUnits(card); });
    if (addBtn) addBtn.addEventListener('click', function () { addToCart(card); });

    // Allow Enter key inside inputs to calculate
    card.querySelectorAll('[data-mc-width], [data-mc-length]').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') calcUnits(card);
      });
    });
  });
});
